<div class="flex gap-x-2 items-center mb-2">
  <div class="w-6/12" tuiGroup [collapsed]="true">
    <tui-input
      class="tui-group__inherit-item w-11/12 tui-group__auto-width-item"
      tuiTextfieldSize="m"
      [formControl]="address.controls.latLong"
      >Координаты (lat,lng)
    </tui-input>
    <button
      (click)="selectLocation$.next()"
      tuiIconButton
      size="m"
      icon="tuiIconMap"
    ></button>
  </div>
  <tui-input
    class="w-6/12"
    tuiTextfieldSize="m"
    [tuiTextfieldLabelOutside]="false"
    [formControl]="address.controls.address"
    >Адрес
  </tui-input>

  <ng-content select="actions"></ng-content>
</div>
